import * as React from "react"
import { connect } from "react-redux"

import { FieldItems, Input } from "@tenforce/toolbox-field-react"

import env from "../../../../env"
import { GlobalState } from "../../../../store"
import { mapDispatchToProps, DispatchProps } from "../../actions"

import Workspace from "./Workspace"
import PlaceholderWorkspace from "./PlaceholderWorkspace"
import LoadMore from "./LoadMore"
import NothingFound from "./NothingFound"
import { createConceptInWorkspaceUrl } from "../../../../util/UrlGenerator"
import { Labels } from "../../../../util/Translations"
import { WorkspacesInfo } from "../../index"

const applicationPath = env.applicationPath

type StateProps = WorkspacesInfo

type Props = StateProps & DispatchProps

export class Workspaces extends React.Component<Props> {
    render(): JSX.Element {
        const {
            workspaces,
            filter,
            isLoading,
            pagination: { count },
        } = this.props
        const { CreateNewConceptTitle, Search } = Labels

        const hasMore = workspaces.length < count

        return (
            <>
                <h3 className="tw-py-4 tw-px-6">{CreateNewConceptTitle}</h3>
                <div className="separator-line is-dimmed"></div>
                <FieldItems extraClasses="tw-flex-1 tw-pt-3 tw-px-2">
                    <Input
                        type="search"
                        placeholder={Search}
                        value={filter}
                        onChangedValue={this.updateFilter}
                        id="workspaceFilter"
                    />
                </FieldItems>
                <div className="tw-mx-3 tw-pb-3">
                    <ul
                        className={`unset ${
                            isLoading && "is-loading is-placeholder"
                        }`}
                        data-ft-workspace-list
                    >
                        {isLoading && workspaces.length === 0 ? (
                            <>
                                <PlaceholderWorkspace />
                                <PlaceholderWorkspace />
                                <PlaceholderWorkspace />
                            </>
                        ) : (
                            <>
                                {workspaces.length > 0 ? (
                                    <>
                                        {workspaces.map((workspace) => (
                                            <Workspace
                                                label={workspace.label}
                                                url={createConceptInWorkspaceUrl(
                                                    applicationPath,
                                                    workspace.id,
                                                )}
                                                key={workspace.id}
                                            />
                                        ))}

                                        {hasMore && <LoadMore />}
                                    </>
                                ) : (
                                    <>{<NothingFound />}</>
                                )}
                            </>
                        )}
                    </ul>
                </div>
            </>
        )
    }

    updateFilter = (filter: string): void => {
        const { filterWorkspaces } = this.props
        filterWorkspaces(filter)
    }
}

const mapStateToProps = (state: GlobalState): StateProps =>
    state.conceptsPage.workspacesInfo

export default connect(mapStateToProps, mapDispatchToProps)(Workspaces)
